export default __webpack_public_path__ + "static/media/misc-pantry2-1440w.2c81c0cc.webp";